import { Skeleton } from "antd";
import classnames from "classnames";

import styles from "./DashBoardHeader.module.scss";

export const DashBoardHeaderPlaceholder = () => {
  return (
    <div className={classnames(styles.root, styles.placeholder)}>
      <div className={styles.wrapperSelect}>
        <Skeleton paragraph={{ rows: 1 }} active />
      </div>
      <div className={styles.wrapper} >
        <Skeleton.Button active />
        <Skeleton.Button active />
      </div>
    </div>
  );
};
